module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAc0lEQVR42u3QMREAIAwEwWigxL8qzAREhOo3M9fnt7q7koseDwAAAAAAAAAAAADA66zdk03fh/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGIDUAAAAAAAAAAAAAAAI7QIJ6+F1nU+NiQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Peru.png
// module id = ILyU
// module chunks = 0 62 63